// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__39pgB","footer":"Form_footer__1lupl"};